import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface CapabilityUnavailableOverlayProps {
  children: ReactNode;
}

export function CapabilityUnavailableOverlay({ children }: CapabilityUnavailableOverlayProps) {
  const { t } = useTranslation();
  const label = t('common.unavailableCapability');

  return (
    <div style={{ position: 'relative' }}>
      <div inert aria-disabled="true" style={{ pointerEvents: 'none' }}>
        {children}
      </div>
      <div
        role="status"
        aria-label={label}
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
          boxSizing: 'border-box',
          background: 'rgba(255, 255, 255, 0.9)',
          color: '#1f2937',
          fontWeight: 600,
          textAlign: 'center',
          cursor: 'not-allowed',
        }}
      >
        {label}
      </div>
    </div>
  );
}